import * as React from 'react'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

interface TagProps {
  label: string
  onClick?: () => void
  className?: string
  iconUrl?: string
}

export function Tag({ label, onClick, className, iconUrl }: TagProps) {
  const base = cn(
    typographyVariants({ variant: 'label-sm' }),
    'srd:px-2.5 srd:py-1 srd:rounded-full srd:border srd:transition-colors srd:shrink-0 srd:flex srd:items-center srd:gap-1',
    onClick
      ? 'srd:cursor-pointer srd:bg-navy-10 srd:text-navy-100 srd:border-navy-30 srd:hover:bg-navy-20 srd:active:bg-navy-30'
      : 'srd:cursor-default srd:bg-navy-10 srd:text-navy-80 srd:border-navy-20',
    className,
  )

  if (onClick) {
    return (
      <button type='button' onClick={onClick} className={base}>
        {iconUrl && <img src={iconUrl} alt={label} className='srd:size-4 srd:rounded-full' />}
        {label}
      </button>
    )
  }

  return (
    <span className={base}>
      {iconUrl && <img src={iconUrl} alt={label} className='srd:size-4 srd:rounded-full' />}
      {label}
    </span>
  )
}
